import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog47 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_47;

  const { title, p } = InfoContent.Blog_47.one;
  const { title2, p2 } = InfoContent.Blog_47.two;
  const { title3, p3 } = InfoContent.Blog_47.three;
  const { title4, p4 } = InfoContent.Blog_47.four;
  const { title5, p5 } = InfoContent.Blog_47.five;
  const { title6, p6 } = InfoContent.Blog_47.six;
  const { title7, p7 } = InfoContent.Blog_47.seven;
  const { title8, p8 } = InfoContent.Blog_47.eight;
  const { title9, p9 } = InfoContent.Blog_47.nine;
  const { title10, p10, p10a, p10b } = InfoContent.Blog_47.ten;
  const { title11, p11 } = InfoContent.Blog_47.eleven;
  const { title12, p12 } = InfoContent.Blog_47.twelve;
  const { title13, p13, p13a } = InfoContent.Blog_47.thirteen;
  const { title14, p14 } = InfoContent.Blog_47.fourteen;
  const { title15, p15 } = InfoContent.Blog_47.fifteen;

  //   const { Ctitle, Cp } = InfoContent.Blog_47.conclusion;

  const { liss10, liss10a } = ListContent.Blog_47.L10;
  const { liss13 } = ListContent.Blog_47.L13;

  return (
    <>
      <Helmet>
        <title>IUI vs IVF: How Doctors Actually Decide</title>

        <meta
          name="description"
          content="Discover evidence-based foods that support fertility and improve chances of conception. Learn which nutrients and diet tips can boost reproductive health naturally."
        />

        <meta name="keywords" content="iui vs ivf" />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/47/IUI-vs-IVF"
        />

        {/* Article Schema */}

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalCondition",
            name: "Azoospermia",
            alternateName: "Zero sperm count",
            description:
              "Azoospermia is a medical condition where a man has a total absence of sperm in his ejaculate, categorized into obstructive and non-obstructive types.",
            associatedAnatomy: {
              "@type": "AnatomicalStructure",
              name: "Male Reproductive System",
            },
            possibleTreatment: [
              {
                "@type": "MedicalTherapy",
                name: "Micro-TESE",
              },
              {
                "@type": "MedicalTherapy",
                name: "Surgical Sperm Retrieval",
              },
            ],
            author: {
              "@type": "Organization",
              name: "Acme Fertility",
            },
            url: "https://www.acmefertility.com/azoospermia-meaning-causes-treatment",
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            "@id": "https://www.acmefertility.com/#author",
            name: "Acme Fertility",
            url: "https://www.acmefertility.com/",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is azoospermia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Azoospermia is a medical condition where a man has a total absence of sperm in his ejaculate.",
                },
              },
              {
                "@type": "Question",
                name: "What are the types of azoospermia?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Azoospermia is categorized into two main types: obstructive azoospermia and non-obstructive azoospermia.",
                },
              },
              {
                "@type": "Question",
                name: "Can azoospermia be treated?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Treatment depends on the underlying cause and may include procedures such as Micro-TESE and surgical sperm retrieval.",
                },
              },
              {
                "@type": "Question",
                name: "What is Micro-TESE?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Micro-TESE is a specialized microsurgical procedure used to search for tiny areas of sperm production in men with non-obstructive azoospermia.",
                },
              },
            ],
          })}
        </script>
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id":
              "https://www.acmefertility.com/azoospermia-meaning-causes-treatment#breadcrumb",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.acmefertility.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Fertility",
                item: "https://www.acmefertility.com/Fertility.php",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Azoospermia Meaning: Types, Causes & Treatment Options",
                item: "https://www.acmefertility.com/azoospermia-meaning-causes-treatment",
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />

              <Info title={title} p={p} />
              <Info title={title2} p={p2} />
              <Info title={title3} p={p3} />
              <Info title={title4} p={p4} />
              <Info title={title5} p={p5} />
              <Info title={title6} p={p6} />
              <Info title={title7} p={p7} />
              <Info title={title8} p={p8} />
              <Info title={title9} p={p9} />
              <Info title={title10} p={p10} />
              <List liss={liss10} />
              <Info p={p10a} />
              <List liss={liss10a} />
              <Info p={p10b} />
              <Info title={title11} p={p11} />
              <Info title={title12} p={p12} />
              <Info title={title13} p={p13} />
              <List liss={liss13} />
              <Info p={p13a} />
              <Info title={title14} p={p14} />
              <Info title={title15} p={p15} />
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog47;
